import { UserNotification } from '../../../entities/v1/UserNotification';
import { ApiService } from '../../ApiService';

export class UserNotificationService {
  public static dismiss(userNotificationId: number): Promise<UserNotification> {
    return ApiService.put<UserNotification>(
      `/api/v1/user_notifications/${userNotificationId}/dismiss`,
    );
  }

  // Get the most recent user notification
  public static get(): Promise<UserNotification> {
    return ApiService.get<UserNotification>('/api/v1/user_notifications');
  }
}
